import { render, staticRenderFns } from "./LmClientsApi.vue?vue&type=template&id=612f9c4e"
import script from "./LmClientsApi.vue?vue&type=script&lang=js"
export * from "./LmClientsApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports